<template>
  <div class="storeInfo">
    <div class="p-stores__brand__icon">
      <img :src="imageUrl" alt="">
    </div>
    <h2 class="storeName">{{ name }}</h2>
  </div>
</template>

<script>
export default {
  name: 'CompaniesMediaLibrariesStoreInfo',
  props: {
    name: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.storeInfo {
  display: inline-flex;
}

.storeName {
  margin: auto;
  margin-left: 20px;
}
</style>
